import { SidebarLayoutNew } from '../components/sidebar-layout-new'
import { BreadcrumbsNew } from '../components/breadcrumbs'
import { Fragment } from 'react/jsx-runtime'
const pages = [
  { name: "Product Highlights", href: "/product-highlights", current: true },
];
export default function ProductHighlights() {
  return (
    <Fragment>
      <SidebarLayoutNew selected_menu="product-highlights">
        <BreadcrumbsNew pages={pages} />
       </SidebarLayoutNew>
    </Fragment>
  );
}